import { lazy } from 'react'

import { PATH_FEATURES } from 'config/paths'

export const NewsRoutes = [
    {
        id: 1,
        module: 'news',
        protected: true,
        exact: true,
        path: PATH_FEATURES.news.root,
        component: lazy(
            () => import('containers/dashboard/features/blog/Blog'),
        ),
    },
    {
        id: 2,
        module: 'news',
        protected: true,
        exact: true,
        path: `${PATH_FEATURES.news.edit}/:id`,
        component: lazy(
            () => import('containers/dashboard/features/blog/EditBlog'),
        ),
    },
    {
        id: 3,
        module: 'news',
        protected: true,
        exact: true,
        path: `${PATH_FEATURES.news.create}`,
        component: lazy(
            () => import('containers/dashboard/features/blog/CreateBlogs'),
        ),
    },
]
